export class Header {
    constructor(header: string, value: string) {
        this.header = header;
        this.value = value;
    }
    header: string;
    value: string;
}
